(() => {
  'use strict';
  const element = document.getElementById('drbo-locale-navigation-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  if (!config.locale || !Array.isArray(config.languages)) return;
  const trimRoot = (root) => typeof root === 'string' ? root.replace(/\/+$/, '') : null;
  const active = config.languages.find((language) => language.code === config.locale);
  const root = trimRoot(config.root) ?? trimRoot(active?.root);
  if (root === null || (root && !root.startsWith('/'))) return;
  const roots = config.languages.map((language) => trimRoot(language.root))
    .filter(Boolean).sort((a, b) => b.length - a.length);
  const resource = /^\/(?:products|collections|pages|blogs|policies|search|cart|recommendations)(?:\/|\.|$)/;

  function localize(value) {
    if (!value || value.startsWith('#')) return value;
    let url;
    try { url = new URL(value, location.href); } catch { return value; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return value;
    let path = url.pathname;
    const prefix = roots.find((candidate) => path === candidate || path.startsWith(candidate + '/'));
    if (prefix) path = path.slice(prefix.length) || '/';
    if (path !== '/' && !resource.test(path)) return value;
    url.pathname = root + path;
    return url.pathname + url.search + url.hash;
  }

  function updateAttribute(node, name) {
    const before = node.getAttribute(name);
    const after = localize(before);
    if (before !== after) node.setAttribute(name, after);
  }

  function updateNode(node) {
    if (!(node instanceof Element)) return;
    if (node.matches('a[href]') && !node.closest('localization-form, [data-locale-navigation-exempt]') &&
        !node.hasAttribute('hreflang') && !node.hasAttribute('download')) {
      updateAttribute(node, 'href');
    }
    // Localization and customer-authentication forms must retain their native actions.
    if (node.matches('form[action]') && !node.querySelector('[name="language_code"], [name="country_code"]')) {
      updateAttribute(node, 'action');
    }
  }

  function updateTree(node) {
    updateNode(node);
    node.querySelectorAll?.('a[href], form[action]').forEach(updateNode);
  }

  function updateThemeRoutes() {
    const routes = window.themeCore?.objects?.routes;
    if (routes) {
      Object.keys(routes).forEach((key) => {
        if (typeof routes[key] === 'string') routes[key] = localize(routes[key]);
      });
      routes.root_url = root || '/';
    }
    // Shopify's documented AJAX root must agree with the rendered locale.
    if (window.Shopify?.routes) window.Shopify.routes.root = root + '/';
  }

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') updateNode(record.target);
      else record.addedNodes.forEach(updateTree);
    }
    updateThemeRoutes();
  });
  observer.observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action']
  });
  // Capture also covers links inserted and clicked within the same event turn.
  for (const eventName of ['pointerdown', 'click', 'auxclick']) {
    document.addEventListener(eventName, (event) => {
      updateNode(event.target.closest?.('a[href]'));
    }, true);
  }
  document.addEventListener('submit', (event) => updateNode(event.target), true);
  document.addEventListener('DOMContentLoaded', () => {
    updateTree(document);
    updateThemeRoutes();
  }, { once: true });
  updateTree(document);
  updateThemeRoutes();
})();
